import React, { useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
// Scss
import "./CapitalProjectsDashboard.scss";

// Icons & Packages
import DropdownAngle from "assets/icons/dropdown-angle.svg";
import DropdownAngleLight from "assets/icons/dropdown-angle-light.svg";
import CPIcon from "assets/icons/cp-icon.svg";
import BriefcaseIcon from "assets/icons/briefcase.svg";
import WalletIcon from "assets/icons/wallet.svg";
import CheckIcon from "assets/icons/check.svg";
import NoteIcon from "assets/icons/note.svg";
import NoteSmallWhiteIcon from "assets/icons/notesmall-white.svg";
import NoteSmallWhiteIconLight from "assets/icons/notesmall-white-light.svg";
import PaymentStatusIcon from "assets/icons/payment-status.svg";
import PaymentStatusIconLight from "assets/icons/payment-status-light.svg";
import ChangeOrderIcon from "assets/icons/change-order.svg";
import ChangeOrderIconLight from "assets/icons/change-order-light.svg";
import ProjectClassificationIcon from "assets/icons/project-classification.svg";
import ProjectClassificationIconLight from "assets/icons/project-classification-light.svg";
import ConstructionIcon from "assets/icons/construction-new.svg";
import RenovationIcon from "assets/icons/renovation-new.svg";
import TransformationIcon from "assets/icons/transformation-new.svg";
import HeartIcon from "assets/icons/heart-new.svg";
import ApprovedIcon from "assets/icons/approved.svg";
import PendingIcon from "assets/icons/pending.svg";
import MapArrowUp from "assets/icons/map-arrow-up.svg";
import MapArrowDown from "assets/icons/map-arrow-down.svg";
import MapLocationBlue from "assets/icons/map-location-blue.svg";
import MapLocationGreen from "assets/icons/map-location-green.svg";
// import DashboardLoader from "assets/images/loader.gif";

// Importing Components

import SmallPie from "components/charts/SmallPie";
import LineChart from "components/charts/LineChart";
import MapChart from "components/charts/MapChart";
import LargePie from "components/charts/LargePie";

// Importing Packages
import "animate.css";

// Variables & Constants
// const apiUrl = "http://nwcdashboards.dig-x.co.in";
const apiUrl = "http://localhost:8080";

function CapitalProjectsDashboard() {
  const selectedTheme = useSelector((state) => state.globalConfig.theme);

  useEffect(() => {
    async function fetchData() {
      const response = await axios.get(`${apiUrl}/api/Main`);
      console.log(response.projects);
    }

    fetchData();
  }, []);
  return (
    <>
      {/* Dropdowns Wrapper */}
      <section className="dropdowns-wrapper">
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Central</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Eastern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>North Western</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Northern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>S. Project</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
        <div className="dropdown-container">
          {selectedTheme === "dark" ? (
            <img src={DropdownAngle} alt="#" />
          ) : (
            <img src={DropdownAngleLight} alt="#" />
          )}
          <select>
            <option>Southern</option>
            <option>Option 2</option>
            <option>Option 3</option>
          </select>
        </div>
      </section>

      {/* Completed Projects Pane */}
      <section className="completed-projects-wrapper">
        <div className="completed-projects-container">
          <div className="cp-title">
            <img src={CPIcon} alt="#" />
            <span>Completed Projects</span>
          </div>
          <div className="cp-list">
            <ul>
              <li>
                <span>Western </span>
                <span>29%</span>
              </li>
              <li>
                <span>Northern East </span>
                <span>17.5%</span>
              </li>
              <li>
                <span>South West </span>
                <span>44.33%</span>
              </li>
              <li>
                <span>Western </span>
                <span>26.09%</span>
              </li>
              <li>
                <span>Northen East </span>
                <span>17.39%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
              <li>
                <span>Southern </span>
                <span>29%</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Left Section Slice And Right Section Slice Info */}
      <section className="grid-wrapper">
        <div className="left-section-container">
          <div className="top">
            <div className="info">
              <div className="basic-tile projects">
                <div className="icon-container">
                  <img src={BriefcaseIcon} alt="#" />
                </div>
                <div className="title">Projects</div>
                <div className="values">630</div>
              </div>
              <div className="budget-revised">
                <div className="budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span>Budget</span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
                <div className="revised-budget">
                  <div className="icon-container">
                    <img src={WalletIcon} alt="#" />
                    <span>
                      Revised <br />
                      Budget
                    </span>
                  </div>
                  <div className="information">
                    <span>33,597</span>
                    <span>SAR</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="info">
              <div className="basic-tile approved-budget">
                <div className="icon-container">
                  <img src={CheckIcon} alt="#" />
                </div>
                <div className="title">
                  Approved <br />
                  Works
                </div>
                <div className="values">
                  <span>13.67bn</span>
                  <span>SAR</span>
                </div>
              </div>
              <div className="basic-tile backlog">
                <div className="icon-container">
                  <img src={NoteIcon} alt="#" />
                </div>
                <div className="title">Backlog</div>
                <div className="values">
                  <span>7.71bn</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="contract-status-wrapper">
              <div className="contract-status-container">
                <div className="header">
                  <span>
                  {
                          selectedTheme === 'dark'? <img src={NoteSmallWhiteIcon} alt="#" />: <img src={NoteSmallWhiteIconLight} alt="#" />
                        }
                    Contract Status
                  </span>
                </div>
                <div className="chart-container">
                  <div className="chart-wrapper">
                    <div className="vertical-bar-container">
                      <div className="chart-system">
                        <span className="code">#</span>
                        <span className="currency">SAR</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">45%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "65%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">81%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "81%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">32%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "32%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">22%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "22%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">36%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "36%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">82%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "82%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">62%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "62%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">54%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "54%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                    <div className="vertical-bar-container">
                      <div className="label">
                        <span>Label</span>
                      </div>
                      <div className="stand-bar">
                        <span className="percentage">77%</span>
                        <div className="bar">
                          <div className="progress" style={{ height: "77%" }}>
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span className="value">272</span>
                        <span className="amount">14191.57M</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right-section-container">
          <div className="top">
            <div className="payment-status-change-order-wrapper">
              <div className="payment-status-change-order-container">
                <div className="payment-status">
                  <div className="header">
                    <span>
                      {selectedTheme === "dark" ? (
                        <img src={PaymentStatusIcon} alt="#" />
                      ) : (
                        <img src={PaymentStatusIconLight} alt="#" />
                      )}
                      Payment Status
                    </span>
                  </div>
                  <div className="info-container">
                    <div className="wrapper">
                      <div className="top approved">
                        <div className="cont">
                          <img src={ApprovedIcon} alt="#" />
                          <span className="title">Approved</span>
                          <span>842.24 M</span>
                        </div>
                      </div>
                      <div className="bottom approved">
                        <div className="chart">
                          <SmallPie colorset={["#239D9C", "#155E5E"]} />
                        </div>
                        <div className="percentage">
                          <span>25%</span>
                        </div>
                      </div>
                    </div>
                    <div className="wrapper">
                      <div className="top pending">
                        <div className="cont">
                          <img src={PendingIcon} alt="#" />
                          <span className="title">Pending</span>
                          <span>1.62 B</span>
                        </div>
                      </div>
                      <div className="bottom pending">
                        <div className="chart">
                          <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                        </div>
                        <div className="percentage">
                          <span>25%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="change-order">
                  <div className="header">
                    <span>
                      {selectedTheme === "dark" ? (
                        <img src={ChangeOrderIcon} alt="#" />
                      ) : (
                        <img src={ChangeOrderIconLight} alt="#" />
                      )}
                      Change Order
                    </span>
                  </div>
                  <div className="info-container">
                    <div className="wrapper">
                      {/* FLoating Notificatins */}
                      <div className="circle normalgreen">27</div>
                      <div className="top">
                        <div className="cont">
                          <img src={ApprovedIcon} alt="#" />
                          <span className="title">Approved</span>
                          <span>842.24 M</span>
                        </div>
                      </div>
                      <div className="bottom approved">
                        <div className="chart">
                          <SmallPie colorset={["#239D9C", "#155E5E"]} />
                        </div>
                        <div className="percentage">
                          <span>25%</span>
                        </div>
                      </div>
                    </div>
                    <div className="wrapper">
                      {/* FLoating Notificatins */}
                      <div className="circle normalorange">27</div>
                      <div className="top">
                        <div className="cont">
                          <img src={PendingIcon} alt="#" />
                          <span className="title">Pending</span>
                          <span>1.62 B</span>
                        </div>
                      </div>
                      <div className="bottom pending">
                        <div className="chart">
                          <SmallPie colorset={["#E9631C", "#8C3B11"]} />
                        </div>
                        <div className="percentage">
                          <span>25%</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="project-classification-wrapper">
              <div className="project-classification-container">
                <div className="header">
                  <span>
                    {selectedTheme === "dark" ? (
                      <img src={ProjectClassificationIcon} alt="#" />
                    ) : (
                      <img src={ProjectClassificationIconLight} alt="#" />
                    )}
                    Project Classification
                  </span>
                </div>
                <div className="chart-container">
                  <div className="chart-wrapper">
                    <div className="horizontal-bar-container">
                      <div className="horizontal-bar">
                        <span>46</span>
                        <div className="bar" style={{ width: "46%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <span>WDN</span>
                      </div>
                      <div className="horizontal-bar blue">
                        <div className="bar" style={{ width: "33%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span>33</span>
                      </div>
                    </div>
                    <div className="horizontal-bar-container">
                      <div className="horizontal-bar">
                        <span>86</span>
                        <div className="bar" style={{ width: "86%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <span>WDN</span>
                      </div>
                      <div className="horizontal-bar blue">
                        <div className="bar" style={{ width: "75%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span>75</span>
                      </div>
                    </div>
                    <div className="horizontal-bar-container">
                      <div className="horizontal-bar">
                        <span>35</span>
                        <div className="bar" style={{ width: "35%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <span>WDN</span>
                      </div>
                      <div className="horizontal-bar blue">
                        <div className="bar" style={{ width: "42%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span>42</span>
                      </div>
                    </div>
                    <div className="horizontal-bar-container">
                      <div className="horizontal-bar">
                        <span>68</span>
                        <div className="bar" style={{ width: "68%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                      </div>
                      <div className="info">
                        <span>WDN</span>
                      </div>
                      <div className="horizontal-bar blue">
                        <div className="bar" style={{ width: "55%" }}>
                          <div className="progress">
                            <div className="glow"></div>
                          </div>
                        </div>
                        <span>55</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Progress Graph Section */}
      <section className="projects-progress-graph-wrapper">
        <div className="projects-progress-graph-container">
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info darkblue">
              <div className="head">
                <span>
                  <img src={ConstructionIcon} alt="#" />
                  Construction Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalgreen"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalgreen">
              <div className="head">
                <span>
                  <img src={RenovationIcon} alt="#" />
                  Renovation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white wastewater">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white wastewater">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalorange"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalorange">
              <div className="head">
                <span>
                  <img src={TransformationIcon} alt="#" />
                  Transformation Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white tse">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white tse">
                  <span>SAR</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
          <div className="project-progress-graph">
            <div className="vertical-progress-container">
              <div className="progress-bar">
                <div
                  className="progress normalblue"
                  style={{ width: "53.31%" }}
                ></div>
              </div>
              <span>56.31%</span>
            </div>
            <div className="project-name-info normalblue">
              <div className="head">
                <span>
                  <img src={HeartIcon} alt="#" />
                  Supportive Projects
                </span>
              </div>
              <div className="body">
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
                <div className="small-section white supportive">
                  <span>Projects</span>
                  <span>9,540</span>
                  <span>SAR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Project Information On Charts */}
      <section className="information-charts-wrapper">
        <div className="information-charts-container">
          <div className="completed-projects-chart">
            <div className="header">
              <span>Completed Projects</span>
            </div>
            <div className="body">
              <div className="top">
                <div className="chart-container">
                  <div className="blackhole underlay"></div>
                  <div className="blackhole"></div>
                  <div className="pie">
                    <LargePie colorset={"#24A0D9"} />
                  </div>
                </div>
                <div className="chart-per-projects">
                  <span>65%</span>
                  <span>10 Projects</span>
                </div>
              </div>
              <div className="bottom">
                <div className="chart-container">
                  <LineChart />
                </div>
              </div>
            </div>
          </div>
          <div className="projects-map-chart">
            <div className="header">
              <span>Projects Map</span>
            </div>
            <div className="chart-container">
              <MapChart />
              <div className="floating-info">
                <div className="maximum-projects">
                  <div className="arrow-container">
                    <img src={MapArrowUp} alt="#" />
                  </div>
                  <div className="info">
                    <span>Maximum Projects</span>
                    <span>117</span>
                    <span>
                      <img src={MapLocationBlue} alt="#" />
                      Location
                    </span>
                  </div>
                </div>
                <div className="minimum-projects">
                  <div className="arrow-container">
                    <img src={MapArrowDown} alt="#" />
                  </div>
                  <div className="info">
                    <span>Maximum Projects</span>
                    <span>117</span>
                    <span>
                      <img src={MapLocationGreen} alt="#" />
                      Location
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CapitalProjectsDashboard;
